import React from 'react'
import B1WhyHead from './B1WhyHead'
import "./../../A2Page/A2Page.css"
import B1WhyMain from './B1WhyMain'

const B1Why = () => {
  return (
    <div className='a2WhyContainer'>
      <B1WhyHead/>
      <B1WhyMain/>
    </div>
  )
}

export default B1Why
